import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";

import { ProductImageWrapper } from "@/components/Product/ProductImage/productImage.component";
import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

type Props = {
    title: string | undefined;
    medias?: null | Array<Media>;
    rendition?: ProductImageRendition;
    renditions?: ProductImageRenditions;
    isEcoChequesAccepted: boolean;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImageContainer = ({
    title,
    medias,
    renditions,
    isEcoChequesAccepted,
    className,
    lazyLoad = false,
    parentFit = false
}: Props) => {
    if (!medias || medias.length === 0) {
        return null;
    }

    return (
        <BreakpointProvider>
            <ProductImageWrapper
                title={title}
                medias={medias}
                renditions={renditions}
                isEcoChequesAccepted={isEcoChequesAccepted}
                className={className}
                lazyLoad={lazyLoad}
                parentFit={parentFit}
            />
        </BreakpointProvider>
    );
};

export { ProductImageContainer };
